// This file is generated by a script and should not be modified directly.
const markdown: string =
  "The location information consists of:\n\n- The `center` of the municipality\n- The bounding box (`bbox`) that defines the area of the municipality.\n\nThe `center` and `bbox` fields are both in [GeoJSON](https://en.wikipedia.org/wiki/GeoJSON) format.\n"
export default markdown
